<template>
    <my-form v-model="form" table>
        <el-form-item label="审核意见" prop="shyj" class="table-full-row">
            <el-input v-model="form.shyj" type="textarea" :rows="4"></el-input>
        </el-form-item>

        <template slot="btn" class="btn">
            <el-button icon="el-icon-circle-close" type="danger" @click="funSend('3')">
                退回
            </el-button>    
            <el-button icon="el-icon-circle-check" type="primary" @click="funSend('6')">
                通过
            </el-button>
        </template>
    </my-form>
</template>

<script>
import FORM_PAGE_MIXIN from "@views/mixins/form-page";

export default {
    mixins: [FORM_PAGE_MIXIN],
    props: {
        row: {
            type: Object,
        },
    },
    data() {
        var that = this;
        return {
            form:{
                shyj:'',
            }
        };
    },
    methods: {
        funSend(val) {
            var that = this
            if(val==='3'&&!that.form.shyj){
                ShowMsg('请填写退回意见！','error');
                return;
            }else{
                that.$post(`${this.getGetters('mngUrl')}/manage/business/auditzbhxrgs/sh.json`, {
                    shbj:val,
                    shyj:escape(escape(that.form.shyj)),
                    rows:that.row.gscode
                }, (data, res) => {
                    ShowMsg('审核成功', 'success');
                    that.cancleHandler();
                });
            }
        },
        cancleHandler() {
            this.$emit('cancle');
        }
    },
};
</script>

<style lang="scss" scoped>
</style>